import { Query } from '@datorama/akita';
import { InventoryAdjustmentState, inventoryAdjustmentStore } from './inventory-adjustment.store';

export class InventoryAdjustmentQuery extends Query<InventoryAdjustmentState> {
  isLoading = this.selectLoading();
  inventoryAdjustmentDateGroups = this.select(x => x.inventoryAdjustmentDateGroups);
}

export const inventoryAdjustmentQuery = new InventoryAdjustmentQuery(inventoryAdjustmentStore);
